// AI recommendation GUIDs
export const VIEW_RECOMMENDATION_WIDGET_BIG = "55f0a1337e8d41f888f8dbf6a164709c";
export const VIEW_RECOMMENDATION_WIDGET_SMALL = "6c9fe2fe532d4c52879295b2a2bcb1f6";
export const STUDY_RECOMMENDATIONS_SELECT_SUBJECT = "4c5fe9bbd59a46b29256f362fbd3284b";
export const STUDY_RECOMMENDATIONS_START_TOPIC = "6a4d30313da8476e9623f9a22b5a03d6";
export const VIDEOS_AND_OFFLINE_RECOMMENDATIONS = "7a113da20b0c43159130e16293390ec1";
export const DRILLS_RECOMMENDED = "1a4813496b074ef08c7c376af916f1a1";

// AI Chat GUIDs
export const AI_CHAT_SELECT_SUBJECT = "26192792d1da4183bbfe9e916d40ce22";
export const AI_CHAT_CLOSE = "b59ebcda8ebd4c77a0ce2423852330a2";
export const AI_CHAT_MINIMIZE_OR_EXPAND_PANEL = "830b2a1f51b740ac9238a0c0f8e869c1";
export const AI_CHAT_SEND_MESSAGE = "53d3878efea943fd9940adc2fff60bd2";
export const AI_CHAT_SEND_FEEDBACK = "7b8aa7e52b06448589afdae0e8148ec0";
export const AI_CHAT_CLOSE_FEEDBACK = "339f299db1374397ab57024b719ecae5";
export const AI_CHAT_INACTIVITY_MESSAGE = "778a97180c8f4537a386eec9fc300dd6";
export const AI_CHAT_INACTIVITY_MESSAGE_CLOSE_BUTTON = "46bbb8f3838e4f12b1f56bc0ffb2e76b";
export const AI_CHAT_INACTIVITY_MESSAGE_NEW_BUTTON = "2b22dc90f712451683fa57081980f3d8";